<template>
  <page>
    <div slot="head" class="page-head-default">
      <img src="../../assets/imgs/back.png" alt="" @click="onBack" />
      {{ i18n.continue_with_whatsapp }}
    </div>
    <div class="login-wa-warp">
      <img
        class="top-tips-pic"
        src="../../assets/imgs/img_login_code.png"
        alt="img_login"
      />
      <template v-if="!isExpired">
        <div class="top-tips">
          {{ isMobile ? i18n.open_in_whatsapp : i18n.scan_qr_whatsapp }}
        </div>
        <div class="qr-box" v-if="!isMobile && waLink">
          <vue-qr :text="waLink" :size="400"></vue-qr>
        </div>
        <div v-if="isMobile && waLink" class="btn open-whatsapp" @click="onOpenWhatsapp">
          {{ i18n.continue_with_whatsapp }}
        </div>
        <div class="waiting-tips">{{ i18n.waiting_approval }}</div>
      </template>
      <template v-else>
        <div class="top-tips">{{ i18n.session_expired }}</div>
        <div class="btn" @click="createSession()">{{ i18n.retry }}</div>
      </template>
    </div>
  </page>
</template>

<script>
import VueQr from "vue-qr"
import UserAuth from "../../mixins/user_auth"
import { mapState } from "vuex"

// WhatsApp登录等待页:桌面端扫二维码/移动端唤起失败的兜底页,也可点按钮重新唤起
export default {
  components: {
    VueQr
  },
  mixins: [UserAuth],
  computed: {
    ...mapState(["user"]),
    i18n() {
      return this.$t("login")
    }
  },
  watch: {
    user(val, oldVal) {
      if (val && !oldVal) {
        // 带机柜qrcode的扫码租借场景,登录后直接进套餐选择页(同游客模式体验)
        if (this.qrcode) {
          this.$router.push("/selectPakage?cabinetshow=true")
        } else {
          this.$router.push("/")
        }
      }
    }
  },
  methods: {
    onOpenWhatsapp() {
      window.location.href = this.waLink
    },
    onBack() {
      this.$router.replace("/login")
    }
  },
  created() {
    this.createSession()
  }
}
</script>

<style lang="less">
.login-wa-warp {
  color: #161616;
  font-size: 28px;
  background-color: #fff;
  padding: 0 55px;
  position: fixed;
  top: 80px;
  bottom: 0;
  left: 0;
  right: 0;
  .top-tips {
    padding: 60px 0 40px;
    text-align: center;
    line-height: 40px;
    &-pic {
      display: block;
      width: 56%;
      margin: 52px auto 0;
    }
  }
  .qr-box {
    display: flex;
    justify-content: center;
    padding: 40px 0;
  }
  .waiting-tips {
    padding-top: 40px;
    text-align: center;
    color: #999;
    font-size: 24px;
  }
  .btn {
    margin: 40px 24px 0;
  }
  .open-whatsapp {
    background-color: #25d366;
    color: #fff;
  }
}
</style>
